var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonDatabase = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M24 44.38c9.941 0 18-2.262 18-5.053s-8.059-5.054-18-5.054-18 2.262-18 5.054c0 2.791 8.059 5.054 18 5.054z", fill: fills.base }),
        React.createElement("path", { d: "M41.997 26.267H6V39.34h35.997V26.266z", fill: fills.base }),
        React.createElement("path", { d: "M24 31.227c9.941 0 18-2.262 18-5.054 0-2.79-8.059-5.054-18-5.054S6 23.382 6 26.173c0 2.792 8.059 5.054 18 5.054z", fill: fills.light }),
        React.createElement("path", { d: "M24 26.966c9.941 0 18-2.262 18-5.054 0-2.791-8.059-5.054-18-5.054S6 19.121 6 21.912c0 2.792 8.059 5.054 18 5.054z", fill: fills.base }),
        React.createElement("path", { d: "M41.997 9.15H6v12.776h35.997V9.15z", fill: fills.base }),
        React.createElement("path", { d: "M24 14.108c9.941 0 18-2.263 18-5.054C42 6.263 33.941 4 24 4S6 6.263 6 9.054c0 2.791 8.059 5.054 18 5.054z", fill: fills.light }),
        React.createElement("path", { d: "M10.022 19.314c.596-.071 1.005-.74.915-1.495-.09-.755-.647-1.31-1.243-1.238-.596.072-1.006.741-.915 1.496.09.755.647 1.309 1.243 1.237zM10.022 36.652c.596-.072 1.005-.741.915-1.496-.09-.755-.647-1.309-1.243-1.237-.596.07-1.006.74-.915 1.495.09.755.647 1.31 1.243 1.238z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
